/* eslint-disable react/forbid-dom-props */
import React from 'react';

// ── Badge ──────────────────────────────────────────────────────
export function Badge({ children, variant = 'navy', style }) {
  return (
    <span className={`badge badge-${variant}`} style={style}>
      {children}
    </span>
  );
}

// ── Spinner ────────────────────────────────────────────────────
export function Spinner({ size = 20, color = 'var(--gold)' }) {
  return (
    <svg
      width={size} height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      style={{ animation: 'spin 0.8s linear infinite' }}
    >
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <circle cx="12" cy="12" r="9" strokeOpacity="0.25" />
      <path d="M12 3a9 9 0 0 1 9 9" />
    </svg>
  );
}

// ── EmptyState ────────────────────────────────────────────────
export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '3rem 1.5rem',
      gap: '.75rem', color: 'var(--text-muted)',
      textAlign: 'center',
    }}>
      {Icon && (
        <div style={{
          width: 48, height: 48,
          background: 'var(--bg-hover)',
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon size={20} color="var(--text-muted)" />
        </div>
      )}
      {title && <div style={{ fontSize: '.9rem', fontWeight: 500, color: 'var(--text-secondary)' }}>{title}</div>}
      {description && <div style={{ fontSize: '.8rem' }}>{description}</div>}
      {action}
    </div>
  );
}

// ── Modal ─────────────────────────────────────────────────────
export function Modal({ isOpen, onClose, title, children, footer, width = 480 }) {
  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="modal" style={{ maxWidth: width }}>
        {title && (
          <div className="modal-header">
            <div className="modal-title">{title}</div>
            <button
              className="btn btn-ghost btn-sm"
              onClick={onClose}
              style={{ padding: '.25rem .375rem' }}
            >
              ×
            </button>
          </div>
        )}
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

// ── ConfirmModal ───────────────────────────────────────────────
export function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmLabel = 'Confirmar', danger = false }) {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width={380}
      footer={
        <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>Cancelar</button>
          <button
            className={`btn btn-sm ${danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={() => { onConfirm(); onClose(); }}
          >
            {confirmLabel}
          </button>
        </div>
      }
    >
      <p style={{ fontSize: '.875rem', color: 'var(--text-secondary)', margin: 0 }}>{message}</p>
    </Modal>
  );
}
